import { StorageManager } from 'src/app/common/storage-manager.class';

import {
    Form,
    FormField,
    FormSection,
    FormType,
    InputType,
    ReactiveDropdownCatalogs,
} from '@fitogest/reactive-form-builder/interfaces';
import { PlanAbonadoEnvironmentDefinition } from '../../environment-variables';
import { FertirrigacionModel } from 'src/app/models/tareas/fertirrigacion.model';
import { PlanAbonadoListsDefinition } from './list-variables';
import { PlanAbonadoModel } from 'src/app/models/tareas/plan-abonado.model';

export class PlanAbonadoFormDefinition {
  public formType!: FormType;

  public env: PlanAbonadoEnvironmentDefinition =
    new PlanAbonadoEnvironmentDefinition();

  public lists: PlanAbonadoListsDefinition =
    new PlanAbonadoListsDefinition();

  public formFields!: Form<PlanAbonadoModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public lastFieldEdited = '';

  public tag = '';

  public openDialog = false;

  public requestType: FormType = FormType.CREATION;

  public cliente = StorageManager.getClient();

  public usuario = StorageManager.getUser();

  public model: PlanAbonadoModel = {
    id_cliente: +(this.cliente?.id ?? 0),
    id_usuario: +StorageManager.getUser().id,
  };

  public horaInicio = '';

  public horaFin = '';

  public now = new Date();

  public getFormFields(): FormField<any>[] {
    const formFields: FormField<any>[] = [
      {
        name: 'programa_calculo',
        label: 'Programa/Herramienta de Cálculo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'necesidad_uf_n',
        label: 'Necesidad UF N (Kg/Ha)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 2
      },
      {
        name: 'necesidad_uf_p205',
        label: 'Necesidad UF P205 (Kg/Ha)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 3
      },
      {
        name: 'necesidad_uf_k20',
        label: 'Necesidad UF K20 (Kg/Ha)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 4
      },
      {
        name: 'objetivo_produccion',
        label: 'Objetivo Producción (Kg/Ha)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 5
      },
      {
        name: this.formType < 3 ? 'id_cultivo_precedente' : 'cultivo_precedente',
        label: 'Cultivo Precedente',
        input: {
          type: InputType.DROPDOWN_SEARCH,
          isEditable: true,
          data: this.lists.cultivos_precedentes,
          dropdownConfiguration: {
            valuePrimaryKey: 'id'
          }
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 6
      },
      {
        name: this.formType < 3 ? 'id_cultivo' : 'cultivo',
        label: 'Cultivo',
        input: {
          type: InputType.DROPDOWN_SEARCH,
          isEditable: true,
          data: this.lists.cultivos,
          dropdownConfiguration: {
            valuePrimaryKey: 'id'
          }
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 7
      },
      {
        name: this.formType < 3 ? 'id_comunidad_regantes' : 'comunidad_regantes',
        label: 'Comunidad de Regantes',
        input: {
          type: InputType.DROPDOWN_SEARCH,
          isEditable: true,
          data: this.lists.comunidadesRegantes,
          dropdownConfiguration: {
            valuePrimaryKey: 'id'
          }
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        buttons: [
          {
            class: 'btn btn-success border rounded-circle shadow-sm p-0 d-flex align-items-center justify-content-center',
            style: `
                width: 26px;
                height: 26px;
                margin-left: 6px;
                font-size: .95rem;
                transform: translateY(-0.5rem);
            `,
            icon: 'fa fa-plus',
            label: '',
            tooltip: 'Añadir nuevo valor',
            tooltipPosition: 'top',
            function: () => this.openDialog = true
          }
        ],
        order: 8,
      },
      {
        name: 'codigo_regfer',
        label: 'Código REGFER',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 9
      },
      {
        name: 'fecha_asesoramiento',
        label: 'Fecha Elaboración Plan Abonado',
        input: { type: InputType.CALENDAR, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 10
      },
    ];

    this.fieldNames = this.fieldNames.concat(
      formFields.filter((it) => it.conditions.isVisible)
    );
    this.fieldLabels = this.fieldLabels.concat(
      formFields.filter((it) => it.conditions.isVisible).map((it) => it.label)
    );
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  private getFormSections(): FormSection<FertirrigacionModel>[] {
    const sections: FormSection<FertirrigacionModel>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1,
      },
      {
        name: '',
        width: 6,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 2,
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  private getHiddenFields(): FormField<any>[] {
    const hiddenFields: FormField<any>[] = [
      {
        name: 'id',
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.model.id,
          isEditable: false,
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1,
      },
      {
        name: 'id_cliente',
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.cliente?.id ?? '',
          isEditable: false,
        },
        updateValue: () => this.cliente?.id ?? '',
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasClients && this.env.userCanSeeClientes,
        },
        order: 2,
      },
      {
        name: 'id_usuario',
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.formType !== FormType.EDITION ? this.usuario?.id ?? '' : '',
          isEditable: false,
        },
        updateValue: () => this.formType !== FormType.EDITION ? this.usuario?.id ?? '' : '',
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 3,
      },
      {
        name: 'cultivo',
        label: '',
        input: { type: InputType.HIDDEN, isEditable: false },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        computed: {
          dependsOn: ['id_cultivo'],
          resolve: (context) => this.resolveCultivoName(
            this.lists.cultivos,
            context.getValue('id_cultivo'),
            this.getModelTextValue('cultivo'),
          ),
        },
        order: 4,
      },
      {
        name: 'cultivo_precedente',
        label: '',
        input: { type: InputType.HIDDEN, isEditable: false },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        computed: {
          dependsOn: ['id_cultivo_precedente'],
          resolve: (context) => this.resolveCultivoName(
            this.lists.cultivos_precedentes,
            context.getValue('id_cultivo_precedente'),
            this.getModelTextValue('cultivo_precedente'),
          ),
        },
        order: 5,
      },
    ];

    return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }


  private resolveCultivoName(
    dropdownData: { values?: Array<{ value?: unknown; raw?: unknown; valueAliases?: readonly unknown[] }> },
    selectedValue: unknown,
    fallbackValue: string,
  ): string {
    const rawValue = this.findDropdownRawValue(dropdownData, selectedValue);
    const cultivo = this.getObjectProperty(rawValue, 'cultivo');

    return cultivo === null || cultivo === undefined || cultivo === '' ? fallbackValue : String(cultivo);
  }

  private findDropdownRawValue(
    dropdownData: { values?: Array<{ value?: unknown; raw?: unknown; valueAliases?: readonly unknown[] }> },
    selectedValue: unknown,
  ): unknown {
    if (selectedValue === null || selectedValue === undefined || selectedValue === '') {
      return null;
    }

    if (typeof selectedValue === 'object') {
      return selectedValue;
    }

    const matchedOption = dropdownData.values?.find((option) => this.matchesDropdownOption(selectedValue, option));

    return matchedOption?.raw ?? matchedOption?.value ?? null;
  }

  private matchesDropdownOption(
    selectedValue: unknown,
    option: { value?: unknown; raw?: unknown; valueAliases?: readonly unknown[] },
  ): boolean {
    return this.valuesMatch(selectedValue, option.value) ||
      this.valuesMatch(selectedValue, this.getObjectProperty(option.raw, 'id')) ||
      (option.valueAliases ?? []).some((alias) => this.valuesMatch(selectedValue, alias));
  }

  private getObjectProperty(value: unknown, propertyName: string): unknown {
    if (typeof value !== 'object' || value === null) {
      return null;
    }

    return (value as Record<string, unknown>)[propertyName] ?? null;
  }

  private valuesMatch(left: unknown, right: unknown): boolean {
    if (left === null || left === undefined || right === null || right === undefined) {
      return false;
    }

    return left === right || String(left) === String(right);
  }

  private getModelTextValue(fieldName: string): string {
    const value = (this.model as Record<string, unknown>)[fieldName];

    if (value === null || value === undefined) {
      return '';
    }

    return String(value);
  }

  constructor(
    type: FormType,
    _model: Record<string, string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;

    this.formFields = {
      name: 'plan-abonado',
      header: 'Plan de Abonado',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1] },
      uploadButton: {
        isEnabled: false,
        label: ''
      },
      signed: false,
      dropdownCatalogs: this.getDropdownCatalogs(),
    };
  }

  private getDropdownCatalogs(): ReactiveDropdownCatalogs {
    return {
      critical: ['id_cultivo', 'id_cultivo_precedente', 'id_comunidad_regantes'],
      deferred: [],
      lazy: [],
    };
  }
}
